import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";

import { ErrorCard, Header, Wrapper } from "src/components";
import tokens from "src/shared/theme/tokens";

export const Error404ScreenContainer = () => {
  const navigate = useNavigate();

  const onClickBackButton = async () => {
    navigate("/");
  };

  return (
    <Wrapper>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(var(--vh, 1vh) * 100)",
          background: tokens.colors.pageBg,
        }}
      >
        <Header isBackButtonVisible={false} />
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingX: { xs: 6, sm: 10 },
            paddingBottom: 8,
            textAlign: "center",
          }}
        >
          <ErrorCard>
            <Typography
              variant="h9Bold"
              component={"p"}
              color={tokens.colors.primary}
              textAlign={"center"}
              marginBottom={3}
            >
              {"404"}
            </Typography>
            <Typography
              variant="h3"
              component={"p"}
              color={tokens.colors.inkSecondary}
              textAlign={"center"}
              marginBottom={6}
            >
              {"We cant seem to find the page you are looking for."}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              type="button"
              sx={{ width: "100px", marginX: "auto" }}
              onClick={onClickBackButton}
            >
              {"Back"}
            </Button>
          </ErrorCard>
        </Box>
      </Box>
    </Wrapper>
  );
};
